export const RCPT_FREE_DATA = 'RCPT_FREE_DATA' // Освобождение всех ресурсов модуля
export const RCPT_GET_RCPT_STATUS_LIST = 'RCPT_GET_RCPT_STATUS_LIST' // Получение списка статусов конфигурации
export const RCPT_POST_STATE = 'RCPT_POST_STATE' // Изменение статуса конфигурации
export const RCPT_GET_RCPT_TYPES_LIST = 'RCPT_GET_RCPT_TYPES_LIST' // Получение списка типов конфигурации
export const RCPT_GET_RCPT_PROPERTIES = 'RCPT_GET_RCPT_PROPERTIES' // Получение списка свойств конфигурации
export const RCPT_GET_GOST_LIST = 'RCPT_GET_GOST_LIST' // Получение списка ГОСТов конфигурации
export const RCPT_GET_GOST_GRADES_LIST = 'RCPT_GET_GOST_GRADES_LIST' // Получение списка типов ГОСТ конфигурации
export const RCPT_SET_FILTER = 'RCPT_SET_FILTER' // Установка фильтра на список конфигураций
export const RCPT_GET_RECEPTURES_LIST = 'RCPT_GET_RECEPTURES_LIST' // Получение списка конфигураций, согласно установленному текущему фильтру
export const RCPT_CREATE_RECEPTURE = 'RCPT_CREATE_RECEPTURE' // Создание новой конфигурации
export const RCPT_UPDATE = 'RCPT_UPDATE' // Изменение заголовка конфигурации
export const RCPT_DELETE = 'RCPT_DELETE' // Удаление конфигурации

export const RCPT_GET_RECEPTURE = 'RCPT_GET_RECEPTURE' // Получение конфигурации по идентификатору
export const RCPT_GET_COMPONENTS = 'RCPT_GET_COMPONENTS' // Получение списка компонентов для конфигурации
export const RCPT_GET_COMP_PROPERTIES = 'RCPT_GET_COMP_PROPERTIES' // Получение свойств компонента
export const RCPT_GET_ROUTE = 'RCPT_GET_ROUTE' // Получение истории состояний конфигурации
export const RCPT_CHANGE_MESSAGE = 'RCPT_CHANGE_MESSAGE' // Добавление/изменение сообщения к конфигурации
export const RCPT_DEL_MESSAGE = 'RCPT_DEL_MESSAGE' // Удаление сообщения в конфигурации
export const RCPT_READ_MESSAGE = 'RCPT_READ_MESSAGE' // Чтение сообщения в конфигурации

export const RCPT_ADD_FILE = 'RCPT_ADD_FILE' // Добавление файла
export const RCPT_DEL_FILE = 'RCPT_DEL_FILE' // Удаление файла

export const RCPT_SET_CURRENT = 'RCPT_SET_CURRENT' // Установка текущей конфигурации
